import _noop from 'lodash/noop';
import _sumBy from 'lodash/sumBy';
import { getSpan } from '../components/Visualizer/utils';
import logNewRelicCustom from '../utils/logNewRelicCustom';
import { getBundleSkusAndPrice } from '../utils/bundle-utils';
import { ANALYTICS_EVENTS, NEW_RELIC_EVENTS, DRAG_AND_DROP } from '../constants';

const addProductToDesign = (
  addProduct, addBundleProducts, metadata,
  choiceId, zone, tubeSpan,
  { trackAddItemToStackEvent = undefined, choiceMetadata, storeProductData, bundles }
) => {
  const {
    BundleDesign: bundleDesign = null,
    Sku: sku = null
  } = choiceMetadata;
  const { value: basePrice } = storeProductData?.[sku]?.pricing || { value: 0 };

  if (bundleDesign) {
    addBundleProducts(metadata, choiceId, bundleDesign, zone);
    const bundleSkusAndPrices = getBundleSkusAndPrice(
      bundles?.data?.[bundleDesign]?.bundleSkus,
      storeProductData
    );

    if (!trackAddItemToStackEvent) {
      return () => false;
    }

    return trackAddItemToStackEvent(bundleSkusAndPrices);
  }
  addProduct(choiceId, choiceMetadata, [...zone, tubeSpan]);

  if (!trackAddItemToStackEvent) {
    return () => false;
  }

  return trackAddItemToStackEvent(sku, basePrice);
};

const removeProductFromDesign = (
  stackItemId, bundleId, removeProduct,
  { trackRemoveItemsFromStackEvent = undefined, choiceMetadata, storeProductData }
) => {
  const { Sku: sku } = choiceMetadata;
  const { value: basePrice } = storeProductData?.[sku]?.pricing || { value: 0 };
  const productRemoved = [{ sku, basePrice }];

  if (bundleId) {
    removeProduct(stackItemId, bundleId);

    if (!trackRemoveItemsFromStackEvent) {
      return () => false;
    }

    return trackRemoveItemsFromStackEvent(ANALYTICS_EVENTS.TRASH_CAN_BUTTON, productRemoved);
  }

  removeProduct(stackItemId);

  if (!trackRemoveItemsFromStackEvent) {
    return () => false;
  }

  return trackRemoveItemsFromStackEvent(ANALYTICS_EVENTS.TRASH_CAN_BUTTON, productRemoved);
};

export const handleDragEnd = (
  event,
  {
    metadata, storeProductData, selectedProduct,
    removeProduct, addProduct, addBundleProducts,
    trackRemoveItemsFromStackEvent, trackAddItemToStackEvent,
    resetDropZones, resetSelected, handleDragEvent, bundles
  }
) => {
  const choiceMetadata = metadata?.[event?.active?.data?.current?.configuratorChoiceId]?.metadata;
  let productRemoved = false;

  if (event?.over?.id === DRAG_AND_DROP.TRASH_CAN) {
    const stackItemId = event.active.id;
    const bundleId = event?.active?.data?.current?.bundleId;
    removeProductFromDesign(
      stackItemId,
      bundleId,
      removeProduct,
      { trackRemoveItemsFromStackEvent, choiceMetadata, storeProductData }
    );
    productRemoved = true;
  }

  if (event?.over?.id.split('-')[0] === DRAG_AND_DROP.DROPPABLE) {
    const { origin } = event.over.data.current;
    const [, , tubeSpan] = getSpan(metadata?.[selectedProduct?.choiceId]?.metadata?.GridSpan);
    const { choiceId } = selectedProduct;
    addProductToDesign(
      addProduct,
      addBundleProducts,
      metadata,
      choiceId,
      origin,
      tubeSpan,
      { trackAddItemToStackEvent, choiceMetadata, storeProductData, bundles }
    );
    resetDropZones();
    logNewRelicCustom(NEW_RELIC_EVENTS.DROP_IN_STACK, { ...choiceMetadata, choiceId });
  } else {
    resetDropZones();
    resetSelected();
    if (!productRemoved) {
      const stackItemId = event.active.id;
      logNewRelicCustom(NEW_RELIC_EVENTS.ORPHAN_DRAG, { stackItemId, selectedProduct });
    }
  }

  const isDragging = false;
  const isVisualizerDrag = false;
  return handleDragEvent(isDragging, isVisualizerDrag);
};

export const handleDragStart = (
  event,
  {
    selectVisualizerItem, select, resetDropZones,
    resetSelected, selectedProduct, handleDragEvent
  }
) => {
  selectVisualizerItem(null);
  if (event.active.data.current?.metadata?.itemId) {
    const itemMetadata = event.active.data.current;
    select(itemMetadata, resetDropZones);
  }
  const isDragging = true;
  const isVisualizerDrag = event.active.data.current?.isVisualizerDrag;
  if (isVisualizerDrag) {
    resetSelected();
    resetDropZones();
  }
  const choiceId = event.active.data.current?.choiceId || selectedProduct?.choiceId;
  logNewRelicCustom(NEW_RELIC_EVENTS.START_DRAG, { isVisualizerDrag, choiceId });
  return handleDragEvent(isDragging, isVisualizerDrag);
};

export const handleDragOver = () => {
  return _noop;
};
